import angular from 'angular'
import template from './template.html'

angular.module('nominas.cotizacion')
  .component('nominasCotizacionEmpleados', {
    controller: Component,
    template: template,
    bindings: {
      data: '<'
    }
  });

function Component($dialog) {
  let $ctrl = this;
  // Flags
  $ctrl.seleccionado = null;
  // Methods
  $ctrl.agregarEmpleado = agregarEmpleado;
  $ctrl.eliminarEmpleado = eliminarEmpleado;
  $ctrl.eliminarTodos = eliminarTodos;

  function agregarEmpleado(item) {
    $ctrl.data.Empleados.push(item);
    $ctrl.agregando = false;
    $ctrl.seleccionado = item;
  }

  function eliminarEmpleado(item) {
    $ctrl.data.Empleados.splice($ctrl.data.Empleados.indexOf(item), 1);
  }

  function eliminarTodos() {
    $dialog.confirm('¿Desea eliminar todos los empleados agregados?').then(function () {
      $ctrl.data.Empleados.length = 0
    });
  }
}



// WEBPACK FOOTER //
// ./src/nominas/cotizacion/components/empleados/controller.js